<h2 mat-dialog-title>{{ 'Problemer med opplasting av dokumenter' }}</h2>
<mat-dialog-content>
  <p>{{ 'Enkelte filer kan ikke lastes opp.'|translate }}</p>
  <p>{{ 'Vennligst velg filer for registrering på nytt og utelat følgende filer:'|translate }}</p>

  @if (modus == 'valideringsfeil') {
    @if (valideringsfeil!.ugyldigeFiltyper.length > 0) {
      <h3>{{ 'Filer med ugyldig filtype'|translate }}</h3>
      <ul>
        @for (fil of valideringsfeil!.ugyldigeFiltyper; track fil) {
          <li>{{ fil.name }}</li>
        }
      </ul>
      <tips stil="liten">
        {{ 'Kun følgende filtypen kan lastes opp til Styreplan:'|translate }}
        <ul>
          @for (mimeinfo of gyldigeFiltyper; track mimeinfo) {
            <li>
              <i [class]="mimeinfo.ikon"></i> {{ mimeinfo.visningsnavn }}
            </li>
          }
        </ul>
      </tips>
    }

    @if (valideringsfeil!.forStoreFiler.length > 0) {
      <h3>{{ 'Filer større enn maksimal opplastingsstørrelse ({maks})'|translate : {maks: maksFilstoerrelse|filstoerrelse} }}</h3>
      <ul>
        @for (fil of valideringsfeil!.forStoreFiler; track fil) {
          <li>{{ fil.name }} ({{ fil.size|filstoerrelse }})</li>
        }
      </ul>
    }

    @if (valideringsfeil!.ikkeLesbareFiler.length > 0) {
      <h3 data-testid="filer-kan-ikke-leses">{{ 'Filer som ikke kan leses'|translate }}</h3>
      <ul>
        @for (fil of valideringsfeil!.ikkeLesbareFiler; track fil) {
          <li>{{ fil.name }} ({{ fil.size|filstoerrelse }})</li>
        }
      </ul>
      <tips>{{ 'Dersom dette er filer som ligger på skydisker som OneDrive og Google Disk kan det hende at du må laste disse ned til din lokale disk før de kan laste opp til Styreplan'|translate }}</tips>
    }

    @if (valideringsfeil!.nyeVersjonerForFilerSendtTilSignering.length > 0) {
      <h3>{{ 'Filer der eksisterende versjon er sendt til signering'|translate }}</h3>
      <ul>
        @for (fil of valideringsfeil!.nyeVersjonerForFilerSendtTilSignering; track fil) {
          <li>{{ fil.name }}</li>
        }
      </ul>
      <tips>{{ 'Dersom en fil med samme navn er sendt til signering kan ikke noen ny versjon av denne registreres.'|translate }}</tips>
    }
  } @else {
    <!-- modus == ugyldigMimetype -->

    <h3>{{ 'Filer med ugyldig filtype'|translate }}</h3>
    @if(tvilsomtOfficeFormat){
      <p>Formatet 'tika/office' er antakelig et Microsoft Office-dokument, men .... todo </p>
    }
    <ul>
      @for (fil of filerMedUgyldigMimetype; track fil) {
        <li>{{ fil.filnavn }} (type: {{ fil.mimetype }})</li>
      }
    </ul>
    <tips stil="liten">
      {{ 'Kun følgende filtypen kan lastes opp til Styreplan:'|translate }}
      <ul>
        @for (mimeinfo of gyldigeFiltyper; track mimeinfo) {
          <li>
            <i [class]="mimeinfo.ikon"></i> {{ mimeinfo.visningsnavn }}
          </li>
        }
      </ul>
    </tips>
  }

</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="false">{{ "Avbryt" | translate }}</button>
</mat-dialog-actions>
